import styled from "styled-components";

export const TextAreaWrapper = styled.div`
  textarea {
    resize: vertical;
    height: 70px;
  }
`;
